import { defineStore } from 'pinia'

declare global {
  interface ThemeStore {
    color: string
  }
}

export default defineStore({
  id: 'theme',
  persist: true,
  state: (): ThemeStore => {
    return {
      color: 'orange'
    }
  },
  actions: {
    setTheme: function (payload?: string) {
      this.color = payload || 'orange'
    }
  },
  getters: {
    getColor: (state: ThemeStore) => state.color
  }
})
